<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Community' }">社区生态</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/receptionLiveList', query: { nav: chatInfo.nav_id } }">直播列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{chatInfo.room_title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div v-if = 'chatInfo !== null' class="head_introduce_all">
      <div class="head_introduce_all_box">
        <div class="head_introduce_all_left lf">
          <div class="head_introduce_title">
            {{chatInfo.room_title}}
          </div>
          <div v-if="chatInfo.room_content !== null" class="head_introduce_content">
            简介：{{chatInfo.room_content}}
          </div>
          <div v-else class="head_introduce_content">
            简介：暂无简介
          </div>
          <div v-if="lookMoreShow" class="head_introduce_more">
            <el-button v-show="!lookMoreOnOff" plain size="mini" @click="lookMore(!lookMoreOnOff)">查看更多<i class="iconfont icon-down"></i></el-button>
            <el-button v-show="lookMoreOnOff" plain size="mini" @click="lookMore(!lookMoreOnOff)">向上收起<i class="iconfont icon-up"></i></el-button>
          </div>
        </div>
        <div class="head_introduce_all_right lf">
          <div class="head_introduce_user">
            <div class="head_introduce_user_box">
              <div class="lf head_introduce_user_left">
                <div class="block"><el-avatar :size="48" :src="userInfo.portrait"></el-avatar></div>
              </div>
              <dl class="lf head_introduce_user_right">
                <dt>
                  <p class="lf head_introduce_user_name">
                    <a @click="userJump(userInfo.user_id)">
                      {{userInfo.user_name}}
                    </a>
                  </p>
                  <p class="lf">
                    <button v-show="userInfo.is_follow === 0"
                    class="greenglga_btn"
                    @click = "addFollow(userInfo.user_id)"
                    >
                      <span>关注</span>
                    </button>
                    <button v-show="userInfo.is_follow === 1"
                    :class="hoverBlean ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
                    @mouseenter="hoverBlean = true"
                    @mouseleave="hoverBlean = false"
                    @click = "cancelFollow(userInfo.user_id)">
                      <span v-show="!hoverBlean">已关注</span>
                      <span v-show="hoverBlean">取消关注</span>
                    </button>
                  </p>
                </dt>
                <dd>
                  <p class="lf head_introduce_user_other">
                    <span>{{userInfo.count}} 人关注</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{userInfo.live_count}} 次直播</span>
                  </p>
                </dd>
              </dl>
            </div>
            <div class="head_introduce_user_info">
              <p>{{userInfo.content}}</p>
            </div>
          </div>
        </div>
        <div v-if="chatInfo.is_live === 0" class="head_introduce_label head_introduce_label_conduct">审核中</div>
        <div v-if="chatInfo.is_doing === 0" class="head_introduce_label head_introduce_label_conduct">预告</div>
        <div v-if="chatInfo.is_doing === 1" class="head_introduce_label head_introduce_label_conduct">进行中</div>
      </div>
    </div>
    <div class="live_box">
       <live-view v-if="chatInfo !== null"
       :chat-info="chatInfo"
       ></live-view>
       <chat-room-view v-if="chatInfo !== null"
       :chat-info="chatInfo"
       :user-info="userInfo"
       >
       </chat-room-view>
    </div>
    <div class="glag_all">
      <div class="title_top_hr">
        <p>
          <i></i>
          <span>相关推荐</span>
          <el-divider></el-divider>
        </p>
      </div>
      <div class="my_load_div" v-if="liveList === null" v-loading="loading"></div>
      <div class="reception_live_list">
        <div v-for="item in liveList" :key="item.id" class="reception_live_item" @click="jump(item.list_id, item.nav_id)">
          <div class="reception_live_item_top">
            <p v-if="item.is_doing === 0" class="reception_live_item_top_icon">
              {{item.start_time}} 开始
            </p>
            <p v-if="item.is_doing === 1" class="reception_live_item_top_icon">
              <i class="iconfont icon-zhengzaibofang"></i>
              进行中
            </p>
            <img :src="item.room_img" alt="">
          </div>
          <div class="reception_live_item_bottom">
            <dl class="reception_live_info">
              <dt class="reception_live_title">
                <span v-if="item.is_doing === 0" class="reception_live_title_tag">即将开始</span>
                <span v-if="item.is_doing === 1" class="reception_live_title_tag">进行中</span>
                {{item.room_title}}
              </dt>
              <dd class="reception_live_user">主讲人：{{item.user_name}}</dd>
            </dl>
            <div class="reception_live_list_item_other">
              <div class="reception_lately_other">
                <span v-if="item.is_doing === 0" ><i class="font_i">{{item.sign_count}}</i> 人报名</span>
                <span v-if="item.is_doing === 1" ><i class="font_i">{{item.on_count}}</i> 人在线</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Live from '../Public/live.vue'
import chatRoom from '../Public/chatRoom.vue'
export default {
  components: {
    liveView: Live,
    chatRoomView: chatRoom
  },
  data () {
    return {
      hoverBlean: false, // 鼠标移入关注按钮记录
      lookMoreShow: false, // 查看开关显示
      roomContent: '', // 直播间简介内容
      lookMoreOnOff: false, // 查看更多开关
      userInfo: null, // 播主信息
      chatInfo: null, // 聊天室相关信息列表
      liveList: null, // 相关推荐列表
      liveListType: { // 相关推荐列表属性
        limit: 1,
        plateName: 'relevant',
        videoType: 'live'
      },
      loading: true
    }
  },
  created () {
    const vueThat = this
    const liveId = { list_id: vueThat.$route.query.id }
    vueThat.myApi.liveDetail(liveId)
      .then(function (res) {
        vueThat.loading = false
        if (res.data.data.data.is_doing === 2 || res.data.data.data.is_doing === 3) {
          vueThat.open(res.data.data.data.video_id, res.data.data.data.is_doing, res.data.data.data.video_status)
        } else {
          vueThat.userInfo = res.data.data.user
          vueThat.chatInfo = res.data.data.data
          vueThat.liveList = res.data.data.live
          vueThat.roomContent = vueThat.chatInfo.room_content
          vueThat.lookMore(vueThat.lookMoreOnOff)
        }
      }).catch(function (erro) {})
  },
  methods: {
    addFollow: function (id) {
      const vueThat = this
      vueThat.myApi.addFollow({ user_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.$alert('关注成功', '温馨提示', {
            type: 'success',
            iconClass: 'iconfont icon-icon_richeng_btn_pass',
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              vueThat.userInfo.is_follow = 1
            }
          })
        }
      })
    },
    cancelFollow: function (id) {
      const vueThat = this
      vueThat.$confirm('是否取消关注?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        vueThat.myApi.cancelFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.userInfo.is_follow = 0
          }
        })
      }).catch(() => {})
    },
    lookMore: function (onOff) {
      const vueThat = this
      if (!onOff) {
        if (vueThat.chatInfo.room_content.length > 73) {
          vueThat.chatInfo.room_content = vueThat.chatInfo.room_content.slice(0, 73) + '...'
          vueThat.lookMoreShow = true
          vueThat.lookMoreOnOff = false
        } else {
          vueThat.lookMoreShow = false
        }
      } else {
        vueThat.chatInfo.room_content = vueThat.roomContent
        vueThat.lookMoreOnOff = true
      }
    },
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 回放弹窗
    open (rid, isDoing, status) {
      if (isDoing === 2) {
        switch (status) {
          case 0:
            this.$alert('直播已结束，回放正在生成中，请稍后观看！', '温馨提示', {
              confirmButtonText: '确认',
              callback: action => {
                window.close()
              }
            })
            break
          case 1:
            this.$alert('直播已结束，请观看回放', '温馨提示', {
              confirmButtonText: '去观看',
              callback: action => {
                this.$router.push({ path: '/receptionVideoDetail/:id', query: { id: rid } })
              }
            })
            break
          case 2:
            this.$alert('该直播已结束', '温馨提示', {
              confirmButtonText: '确认',
              callback: action => {
                window.close()
              }
            })
            break
        }
      } else {
        this.$alert('播主未进行直播，请返回', '温馨提示', {
          confirmButtonText: '确定',
          callback: action => {
            window.close()
          }
        })
      }
    },
    // 跳转详情
    jump (id, navId, isDoing) {
      this.mycommon.detailJump(this, id, navId, isDoing)
    }
  }
}
</script>

<style>
</style>
